/**
 * The Loading component, used while resources load
 * Keep this component as similar as possible to the resource page importing it
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Row,
  Col,
  Input,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  CardTitle,
  CardSubtitle,
} from "reactstrap";
import FormattedNumber from "../../FormattedNumber";

import { FILEEDITOR } from "../../FileUploadEditorForm/utils/fileEditor";
import EditorFormHelpers from "../../FileUploadEditorForm/utils/FileUploadEditorFormHelpers";

import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

const SizeSelectTab = ({ editorTypeId }, context) => {
  const language = useSelector((state) => {
    return state.i18nState.lang;
  });

  const [sizeSelectModalIsOpen, setSizeSelectModalIsOpen] = useState(false);
  const { control, setValue } = useFormContext();
  const fileWidth = useWatch({ control, name: "width" });
  const fileHeight = useWatch({ control, name: "height" });
  const amount = useWatch({ control, name: "amount" });
  const showSmallSizeWarning =
    isNaN(fileHeight) ||
    isNaN(fileWidth) ||
    parseInt(fileHeight) < 10 ||
    parseInt(fileWidth) < 10;

  const showMightBeDevidedHint =
    FILEEDITOR[editorTypeId] &&
    FILEEDITOR[editorTypeId].boundaries &&
    FILEEDITOR[editorTypeId].boundaries.maxNoDevide &&
    parseInt(fileHeight) > FILEEDITOR[editorTypeId].boundaries.maxNoDevide &&
    parseInt(fileWidth) > FILEEDITOR[editorTypeId].boundaries.maxNoDevide;

  // const defaultWarningSize = 120;
  // Disable Hint because it looks too aggresive since default values already fall into this
  const showSmallHint = false;
  // (fileWidth <
  //   (FILEEDITOR && editorTypeId && FILEEDITOR[editorTypeId]
  //     ? FILEEDITOR[editorTypeId].warningSize || defaultWarningSize
  //     : defaultWarningSize) &&
  //   fileHeight <
  //     (FILEEDITOR && editorTypeId && FILEEDITOR[editorTypeId]
  //       ? FILEEDITOR[editorTypeId].warningSize || defaultWarningSize
  //       : defaultWarningSize)) ||
  // fileWidth <
  //   (FILEEDITOR && editorTypeId && FILEEDITOR[editorTypeId]
  //     ? FILEEDITOR[editorTypeId].warningSize || defaultWarningSize
  //     : defaultWarningSize) /
  //     2 ||
  // fileHeight <
  //   (FILEEDITOR && editorTypeId && FILEEDITOR[editorTypeId]
  //     ? FILEEDITOR[editorTypeId].warningSize || defaultWarningSize
  //     : defaultWarningSize) /
  //     2;

  return (
    <Container>
      <div className="h3 mb-3">{context.t("size")}</div>
      <Controller
        name="width"
        control={control}
        render={({ field }) => <Input type="hidden" {...field} />}
      />

      <Controller
        name="height"
        control={control}
        render={({ field }) => <Input type="hidden" {...field} />}
      />

      <Row>
        {FILEEDITOR[editorTypeId]?.availableSizes
          ?.find((avsg) => avsg?.title === "topseller")
          ?.sizes?.map((availableSize) => (
            <Col md={3} xs={6}>
              <Card
                className={`mb-3 ${
                  availableSize[0] === fileWidth &&
                  availableSize[1] === fileHeight
                    ? "border-success bg-light"
                    : "pointer-light"
                }`}
                onClick={() => {
                  setValue("width", availableSize[0]);
                  setValue("height", availableSize[1]);
                }}
              >
                <CardBody>
                  <CardTitle className="h5">
                    <FormattedNumber
                      value={Math.round(availableSize[0] * 10) / 100}
                      language={language}
                      unit="cm"
                      decimals={0}
                    />
                    &nbsp;x&nbsp;
                    <FormattedNumber
                      value={Math.round(availableSize[1] * 10) / 100}
                      language={language}
                      unit="cm"
                      decimals={0}
                    />
                  </CardTitle>
                  <CardSubtitle className="pull-right text-success">
                    <FormattedNumber
                      value={parseFloat(
                        EditorFormHelpers.calculatePrice({
                          // ...widgetConfiguration,
                          editorType: editorTypeId,
                          border: 0,
                          cutting: "rectangular",
                          width: availableSize[0],
                          height: availableSize[1],
                          amount: amount,
                        }).displayPrice
                      )}
                      language={language}
                      unit="€"
                      decimals={2}
                    />
                  </CardSubtitle>
                </CardBody>
              </Card>
            </Col>
          ))}
        <Col md={3} xs={6}>
          <Card
            className={`mb-3 pointer-light ${
              !FILEEDITOR[editorTypeId]?.availableSizes
                ?.find((avsg) => avsg?.title === "topseller")
                ?.sizes?.find(
                  (size) => size[0] === fileWidth && size[1] === fileHeight
                )
                ? "bg-light border-success"
                : ""
            }`}
            onClick={() => {
              setSizeSelectModalIsOpen(true);
            }}
          >
            <CardBody>
              {FILEEDITOR[editorTypeId]?.availableSizes
                ?.find((avsg) => avsg?.title === "topseller")
                ?.sizes?.find(
                  (size) => size[0] === fileWidth && size[1] === fileHeight
                ) && (
                <>
                  <CardTitle className="h5">
                    {context.t("More Sizes")}
                  </CardTitle>
                  <CardSubtitle className="pull-right text-primary">
                    {context.t("select size")}
                  </CardSubtitle>
                </>
              )}
              {!FILEEDITOR[editorTypeId]?.availableSizes
                ?.find((avsg) => avsg?.title === "topseller")
                ?.sizes?.find(
                  (size) => size[0] === fileWidth && size[1] === fileHeight
                ) && (
                <>
                  <CardTitle className="h5">
                    <FormattedNumber
                      value={Math.round(fileWidth * 10) / 100}
                      language={language}
                      unit="cm"
                      decimals={0}
                    />
                    &nbsp;x&nbsp;
                    <FormattedNumber
                      value={Math.round(fileHeight * 10) / 100}
                      language={language}
                      unit="cm"
                      decimals={0}
                    />
                  </CardTitle>
                  <CardSubtitle>
                    <span className="pull-left text-primary">
                      {context.t("change size")}
                    </span>
                    <span className="pull-right text-success">
                      <FormattedNumber
                        value={parseFloat(
                          EditorFormHelpers.calculatePrice({
                            // ...widgetConfiguration,
                            editorType: editorTypeId,
                            border: 0,
                            cutting: "rectangular",
                            width: fileWidth,
                            height: fileHeight,
                            amount: amount,
                          }).displayPrice
                        )}
                        language={language}
                        unit="€"
                        decimals={2}
                      />
                    </span>
                  </CardSubtitle>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        fade={false}
        className="sizeselect-modal"
        isOpen={sizeSelectModalIsOpen}
        size="xl"
        toggle={() => setSizeSelectModalIsOpen(false)}
        centered
      >
        <ModalHeader>{context.t("Select available Size")}</ModalHeader>
        <ModalBody>
          <Row>
            {FILEEDITOR[editorTypeId]?.availableSizes.map(
              (availableSizesCategory, index) => {
                return (
                  <Col key={`sizemodal-${index}`} md={4}>
                    <strong>{context.t(availableSizesCategory.title)}</strong>
                    <ul className="sizeselect-list">
                      {availableSizesCategory.sizes.map(
                        (availableSize, index) => {
                          return (
                            <li
                              key={index}
                              className={
                                availableSize[0] === fileWidth &&
                                availableSize[1] === fileHeight
                                  ? "selected py-1"
                                  : "py-1"
                              }
                              onClick={() => {
                                setValue("width", availableSize[0]);
                                setValue("height", availableSize[1]);
                                setSizeSelectModalIsOpen(false);
                              }}
                            >
                              <FormattedNumber
                                value={
                                  Math.round(availableSize[0] * 100) / 1000
                                }
                                language={language}
                                unit="cm"
                                decimals={0}
                              />
                              &nbsp;x&nbsp;
                              <FormattedNumber
                                value={
                                  Math.round(availableSize[1] * 100) / 1000
                                }
                                language={language}
                                unit="cm"
                                decimals={0}
                              />
                              <span className="text-success pull-right">
                                <strong>
                                  <FormattedNumber
                                    value={parseFloat(
                                      EditorFormHelpers.calculatePrice({
                                        // ...widgetConfiguration,
                                        editorType: editorTypeId,
                                        border: 0,
                                        cutting: "rectangular",
                                        width: availableSize[0],
                                        height: availableSize[1],
                                        amount: amount,
                                      }).displayPrice
                                    )}
                                    language={language}
                                    unit="€"
                                    decimals={2}
                                  />
                                </strong>
                              </span>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </Col>
                );
              }
            )}
          </Row>
          <span style={{ display: "none" }}>
            {context.t("square")}
            {context.t("portrait")}
            {context.t("topseller")}
          </span>
        </ModalBody>
        {FILEEDITOR[editorTypeId]?.showDefaultAmounts && (
          <ModalFooter>
            <span className="small">
              {context.t("Displayed price for")} {amount} {context.t("units")}
            </span>
          </ModalFooter>
        )}
      </Modal>
      {(showSmallHint || showSmallSizeWarning || showMightBeDevidedHint) && (
        <div className="h5 text-danger pt-4">⚠️ {context.t("Warning")}</div>
      )}
      {showSmallHint && (
        <p className="text-danger">
          {context.t(
            "The size of your design looks very small. Please double check you did not confuse MM with CM. Your selected measurements are:"
          )}
        </p>
      )}
      {showSmallSizeWarning && (
        <p className="text-danger">
          {context.t("The minimum size for height and width is 10mm ")}
        </p>
      )}
      {showMightBeDevidedHint && (
        <p className="text-danger">
          {context.t(
            "For technical reasons, your design may need to be divided into several parts, as both dimensions exceed the maximum manufacturable size. It can be installed without any visible gap."
          )}
        </p>
      )}
    </Container>
  );
};

/**  define proptype for the 'translation' function  */
SizeSelectTab.contextTypes = {
  t: PropTypes.func,
};
export default SizeSelectTab;
